import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    modules,
    strict: process.env.NODE_ENV !== 'production',
    state: {
        token: null,
        server: 'https://warehouse.modijiaoyu.com/api',
        web: 'https://warehouse.modijiaoyu.com ',
        version: "4.1.1",
    },
    mutations: {
        // 用户刷新 token 成功，使用新的 token 替换掉本地的token
        refreshToken(state, token) {
            state.token = token;
            localStorage.token = token;
            //axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
            axios.defaults.headers.common['Authorization'] ='Bearer ' + state.token
        },
    },
})
